var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingBtnTxtOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 54,
    viewBox: "0 0 214 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6743 21.4193V7.35199H22.4766V3.28003H39.5477V7.35199H33.35V21.4193H28.6804H28.6743Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9916 21.4194V11.311H47.0897V21.4194H42.5361V2.4646H47.0897V7.32833H53.1957C55.1454 7.32833 56.539 8.59635 56.539 10.4954V21.4194H51.9855H51.9916Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3301 21.4192C61.3804 21.4192 59.9868 20.1512 59.9868 18.2522V10.4952C59.9868 8.59615 61.3804 7.32812 63.3301 7.32812H70.6463C72.645 7.32812 73.9897 8.63782 73.9897 10.5845V12.9836C73.9897 14.9303 72.8773 16.0138 70.8786 16.0138H64.5403V17.5318H69.21V16.6924H73.7635V18.1629C73.7635 20.1095 72.4189 21.4192 70.4202 21.4192H63.3363H63.3301ZM69.4362 11.2155H64.5342V12.8229H69.4362V11.2155Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9297 21.4192V15.3827C84.9297 13.436 86.1399 12.1918 88.0897 11.8525L95.9865 10.4951V7.32806H89.8072V9.81648H85.162V6.5601C85.162 4.61342 86.5555 3.2561 88.5542 3.2561H97.2395C99.2382 3.2561 100.632 4.61342 100.632 6.5601V10.6975C100.632 12.6442 99.446 13.8884 97.4718 14.2278L89.5749 15.5851V17.3472H100.399V21.4192H84.9358H84.9297Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.268 13.055V7.16133H106.414V13.055H103.761V4.8396H109.977C111.114 4.8396 111.927 5.57779 111.927 6.68508V13.055H109.274H109.268Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.876 13.055C114.739 13.055 113.926 12.293 113.926 11.1798V6.67918C113.926 5.57189 114.739 4.8337 115.876 4.8337H119.439V2H122.092V13.055H115.876ZM119.439 7.15543H116.585V10.7273H119.439V7.15543Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.122 21.4195V18.5263L142.983 21.4195H135.74C133.741 21.4195 132.348 20.0622 132.348 18.1155V6.55449C132.348 4.60781 133.741 3.25049 135.74 3.25049H146.375C148.374 3.25049 149.767 4.60781 149.767 6.55449V9.06672H145.122V7.32245H136.993V17.3416H145.122V14.7877H141.314V10.6681H149.767V18.1096C149.767 20.0562 148.374 21.4136 146.375 21.4136H145.122V21.4195Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.953 21.4193L161.472 15.5852L156.992 21.4193H151.418L158.477 12.1681L151.882 3.28003H157.457L161.472 8.77479L165.488 3.28003H171.062L164.516 12.1919L171.527 21.4193H165.953Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.184 21.4195V18.5263L184.044 21.4195H176.801C174.803 21.4195 173.409 20.0622 173.409 18.1155V6.55449C173.409 4.60781 174.803 3.25049 176.801 3.25049H187.436C189.435 3.25049 190.829 4.60781 190.829 6.55449V9.06672H186.184V7.32245H178.054V17.3416H186.184V14.7877H182.376V10.6681H190.829V18.1096C190.829 20.0562 189.435 21.4136 187.436 21.4136H186.184V21.4195Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6743 21.4193V7.35199H22.4766V3.28003H39.5477V7.35199H33.35V21.4193H28.6804H28.6743Z",
    fill: "url(#paint0_linear_111_877)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9916 21.4194V11.311H47.0897V21.4194H42.5361V2.4646H47.0897V7.32833H53.1957C55.1454 7.32833 56.539 8.59635 56.539 10.4954V21.4194H51.9855H51.9916Z",
    fill: "url(#paint1_linear_111_877)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3301 21.4192C61.3804 21.4192 59.9868 20.1512 59.9868 18.2522V10.4952C59.9868 8.59615 61.3804 7.32812 63.3301 7.32812H70.6463C72.645 7.32812 73.9897 8.63782 73.9897 10.5845V12.9836C73.9897 14.9303 72.8773 16.0138 70.8786 16.0138H64.5403V17.5318H69.21V16.6924H73.7635V18.1629C73.7635 20.1095 72.4189 21.4192 70.4202 21.4192H63.3363H63.3301ZM69.4362 11.2155H64.5342V12.8229H69.4362V11.2155Z",
    fill: "url(#paint2_linear_111_877)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9297 21.4192V15.3827C84.9297 13.436 86.1399 12.1918 88.0897 11.8525L95.9865 10.4951V7.32806H89.8072V9.81648H85.162V6.5601C85.162 4.61342 86.5555 3.2561 88.5542 3.2561H97.2395C99.2382 3.2561 100.632 4.61342 100.632 6.5601V10.6975C100.632 12.6442 99.446 13.8884 97.4718 14.2278L89.5749 15.5851V17.3472H100.399V21.4192H84.9358H84.9297Z",
    fill: "url(#paint3_linear_111_877)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.268 13.055V7.16133H106.414V13.055H103.761V4.8396H109.977C111.114 4.8396 111.927 5.57779 111.927 6.68508V13.055H109.274H109.268Z",
    fill: "url(#paint4_linear_111_877)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.876 13.055C114.739 13.055 113.926 12.293 113.926 11.1798V6.67918C113.926 5.57189 114.739 4.8337 115.876 4.8337H119.439V2H122.092V13.055H115.876ZM119.439 7.15543H116.585V10.7273H119.439V7.15543Z",
    fill: "url(#paint5_linear_111_877)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.122 21.4195V18.5263L142.983 21.4195H135.74C133.741 21.4195 132.348 20.0622 132.348 18.1155V6.55449C132.348 4.60781 133.741 3.25049 135.74 3.25049H146.375C148.374 3.25049 149.767 4.60781 149.767 6.55449V9.06672H145.122V7.32245H136.993V17.3416H145.122V14.7877H141.314V10.6681H149.767V18.1096C149.767 20.0562 148.374 21.4136 146.375 21.4136H145.122V21.4195Z",
    fill: "url(#paint6_linear_111_877)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.953 21.4193L161.472 15.5852L156.992 21.4193H151.418L158.477 12.1681L151.882 3.28003H157.457L161.472 8.77479L165.488 3.28003H171.062L164.516 12.1919L171.527 21.4193H165.953Z",
    fill: "url(#paint7_linear_111_877)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.184 21.4195V18.5263L184.044 21.4195H176.801C174.803 21.4195 173.409 20.0622 173.409 18.1155V6.55449C173.409 4.60781 174.803 3.25049 176.801 3.25049H187.436C189.435 3.25049 190.829 4.60781 190.829 6.55449V9.06672H186.184V7.32245H178.054V17.3416H186.184V14.7877H182.376V10.6681H190.829V18.1096C190.829 20.0562 189.435 21.4136 187.436 21.4136H186.184V21.4195Z",
    fill: "url(#paint8_linear_111_877)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63051 51.9996C3.63184 51.9996 2.23828 50.6423 2.23828 48.6956V45.844H6.88349V47.9276H14.5481V44.5343H5.63051C3.63184 44.5343 2.47054 43.4032 2.47054 41.4566V37.1346C2.47054 35.1879 3.8641 33.8306 5.86277 33.8306H15.6849C17.6836 33.8306 19.0772 35.1879 19.0772 37.1346V39.623H14.432V37.9025H7.11575V40.7958H16.0333C18.032 40.7958 19.1933 41.9269 19.1933 43.8735V48.6896C19.1933 50.6363 17.7997 51.9936 15.8011 51.9936H5.63051V51.9996Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3014 52.0001C24.3027 52.0001 22.9092 50.6428 22.9092 48.6961V37.1351C22.9092 35.1884 24.3027 33.8311 26.3014 33.8311H36.472C38.4706 33.8311 39.8642 35.1884 39.8642 37.1351V48.6961C39.8642 50.6428 38.4706 52.0001 36.472 52.0001H26.3014ZM35.219 37.909H27.5544V47.9281H35.219V37.909Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0158 51.9997C45.0171 51.9997 43.6235 50.6424 43.6235 48.6957V33.8367H48.2687V47.9278H55.4688V33.8367H60.114V48.6957C60.114 50.6424 58.7205 51.9997 56.7218 51.9997H47.0158Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3085 51.9997L71.195 44.5583C70.3332 42.9986 69.8015 42.0461 68.9886 40.5102V51.9997H63.9277V33.8367H69.3859L74.5628 43.0879C75.1679 44.082 75.5408 44.7369 76.1153 45.8025V33.8367H80.7605V51.9997H75.3024H75.3085Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6235 51.9997V33.8367H98.113C100.436 33.8367 102.061 35.4202 102.061 37.6824V48.154C102.061 50.4162 100.436 51.9997 98.113 51.9997H84.6235ZM97.4162 37.9563H89.2626V47.9337H97.4162V37.9563Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.858 51.9999V37.9326H112.66V33.8606H129.731V37.9326H123.534V51.9999H118.864H118.858Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.097 51.9997L141.705 46.2549H137.457V51.9997H132.812V33.8367H145.769C147.768 33.8367 149.161 35.194 149.161 37.1407V42.9509C149.161 44.5345 148.232 45.7132 146.839 46.118L150.555 51.9997H145.097ZM144.516 37.9086H137.457V42.183H144.516V37.9086Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M165.933 51.9997L164.655 47.9278H157.993L156.599 51.9997H151.514L157.712 33.8367H165.26L171.018 51.9997H165.933ZM162.498 40.915C162.174 39.7839 161.752 38.4504 161.52 37.3193C161.239 38.4504 160.798 39.7839 160.426 40.915L159.289 44.1713H163.494L162.498 40.915Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M176.525 52.0001C174.526 52.0001 173.133 50.6428 173.133 48.6961V37.1351C173.133 35.1884 174.526 33.8311 176.525 33.8311H186.671C188.67 33.8311 190.063 35.1884 190.063 37.1351V40.4629H185.418V37.909H177.778V47.9281H185.418V44.9873H190.063V48.6961C190.063 50.6428 188.67 52.0001 186.671 52.0001H176.525Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M205.35 51.9997L200.241 44.9869L198.358 46.6598V51.9997H193.737V33.8367H198.358V40.8019L205.118 33.8367H211.041L203.608 41.6174L211.762 51.9997H205.35Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63051 51.9996C3.63184 51.9996 2.23828 50.6423 2.23828 48.6956V45.844H6.88349V47.9276H14.5481V44.5343H5.63051C3.63184 44.5343 2.47054 43.4032 2.47054 41.4566V37.1346C2.47054 35.1879 3.8641 33.8306 5.86277 33.8306H15.6849C17.6836 33.8306 19.0772 35.1879 19.0772 37.1346V39.623H14.432V37.9025H7.11575V40.7958H16.0333C18.032 40.7958 19.1933 41.9269 19.1933 43.8735V48.6896C19.1933 50.6363 17.7997 51.9936 15.8011 51.9936H5.63051V51.9996Z",
    fill: "url(#paint9_linear_111_877)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3014 52.0001C24.3027 52.0001 22.9092 50.6428 22.9092 48.6961V37.1351C22.9092 35.1884 24.3027 33.8311 26.3014 33.8311H36.472C38.4706 33.8311 39.8642 35.1884 39.8642 37.1351V48.6961C39.8642 50.6428 38.4706 52.0001 36.472 52.0001H26.3014ZM35.219 37.909H27.5544V47.9281H35.219V37.909Z",
    fill: "url(#paint10_linear_111_877)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0158 51.9997C45.0171 51.9997 43.6235 50.6424 43.6235 48.6957V33.8367H48.2687V47.9278H55.4688V33.8367H60.114V48.6957C60.114 50.6424 58.7205 51.9997 56.7218 51.9997H47.0158Z",
    fill: "url(#paint11_linear_111_877)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3085 51.9997L71.195 44.5583C70.3332 42.9986 69.8015 42.0461 68.9886 40.5102V51.9997H63.9277V33.8367H69.3859L74.5628 43.0879C75.1679 44.082 75.5408 44.7369 76.1153 45.8025V33.8367H80.7605V51.9997H75.3024H75.3085Z",
    fill: "url(#paint12_linear_111_877)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6235 51.9997V33.8367H98.113C100.436 33.8367 102.061 35.4202 102.061 37.6824V48.154C102.061 50.4162 100.436 51.9997 98.113 51.9997H84.6235ZM97.4162 37.9563H89.2626V47.9337H97.4162V37.9563Z",
    fill: "url(#paint13_linear_111_877)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M118.858 51.9998V37.9326H112.66V33.8606H129.731V37.9326H123.534V51.9998H118.864H118.858Z",
    fill: "url(#paint14_linear_111_877)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M145.097 51.9997L141.705 46.2549H137.457V51.9997H132.812V33.8367H145.769C147.768 33.8367 149.161 35.194 149.161 37.1407V42.9509C149.161 44.5345 148.232 45.7132 146.839 46.118L150.555 51.9997H145.097ZM144.516 37.9086H137.457V42.183H144.516V37.9086Z",
    fill: "url(#paint15_linear_111_877)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.933 51.9997L164.655 47.9278H157.993L156.599 51.9997H151.514L157.712 33.8367H165.26L171.018 51.9997H165.933ZM162.498 40.915C162.174 39.7839 161.752 38.4504 161.52 37.3193C161.239 38.4504 160.798 39.7839 160.426 40.915L159.289 44.1713H163.494L162.498 40.915Z",
    fill: "url(#paint16_linear_111_877)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M176.525 52.0001C174.526 52.0001 173.133 50.6428 173.133 48.6961V37.1351C173.133 35.1884 174.526 33.8311 176.525 33.8311H186.671C188.67 33.8311 190.063 35.1884 190.063 37.1351V40.4629H185.418V37.909H177.778V47.9281H185.418V44.9873H190.063V48.6961C190.063 50.6428 188.67 52.0001 186.671 52.0001H176.525Z",
    fill: "url(#paint17_linear_111_877)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M205.35 51.9997L200.241 44.9869L198.358 46.6598V51.9997H193.737V33.8367H198.358V40.8019L205.118 33.8367H211.041L203.608 41.6174L211.762 51.9997H205.35Z",
    fill: "url(#paint18_linear_111_877)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_877",
    x1: 2.85667,
    y1: 24.6221,
    x2: 208.658,
    y2: 24.6221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_877",
    x1: 2.85628,
    y1: 24.6222,
    x2: 208.657,
    y2: 24.6222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_877",
    x1: 2.85685,
    y1: 24.622,
    x2: 208.658,
    y2: 24.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_111_877",
    x1: 2.85618,
    y1: 24.622,
    x2: 208.657,
    y2: 24.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_111_877",
    x1: 2.85628,
    y1: 24.6219,
    x2: 208.657,
    y2: 24.6219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_111_877",
    x1: 2.85638,
    y1: 24.622,
    x2: 208.657,
    y2: 24.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_111_877",
    x1: 2.85636,
    y1: 24.6223,
    x2: 208.657,
    y2: 24.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_111_877",
    x1: 2.85688,
    y1: 24.6221,
    x2: 208.658,
    y2: 24.6221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_111_877",
    x1: 2.85668,
    y1: 24.6223,
    x2: 208.658,
    y2: 24.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_111_877",
    x1: 2.23828,
    y1: 29.3836,
    x2: 208.039,
    y2: 29.3836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_111_877",
    x1: 2.238,
    y1: 29.384,
    x2: 208.039,
    y2: 29.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_111_877",
    x1: 2.2384,
    y1: 29.3837,
    x2: 208.039,
    y2: 29.3837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_111_877",
    x1: 2.23814,
    y1: 29.3837,
    x2: 208.039,
    y2: 29.3837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_111_877",
    x1: 2.23832,
    y1: 29.3837,
    x2: 208.039,
    y2: 29.3837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_111_877",
    x1: 2.23869,
    y1: 29.3838,
    x2: 208.04,
    y2: 29.3838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_111_877",
    x1: 2.23846,
    y1: 29.3837,
    x2: 208.039,
    y2: 29.3837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_111_877",
    x1: 2.23793,
    y1: 29.3837,
    x2: 208.039,
    y2: 29.3837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_111_877",
    x1: 2.23795,
    y1: 29.384,
    x2: 208.039,
    y2: 29.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_111_877",
    x1: 2.23864,
    y1: 29.3837,
    x2: 208.04,
    y2: 29.3837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6374A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6B6FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7968A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8164A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8463A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#70548B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3F2F4E",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010100",
    stopOpacity: 0.92
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingBtnTxtOn);
export default __webpack_public_path__ + "static/media/landingBtnTxtOn.c19e9d4bf0c7a7922f02c266220413d1.svg";
export { ForwardRef as ReactComponent };